import script from "./DashboardStatsUserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardStatsUserCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__